<template>
  <div>
    <div style="float: right;width:73%">
      <div style="height:40px;background: #54a890;padding-left:20px;">
        <a-icon type="book" style="fontSize:20px;color:#fff;" />
        <span class="u_spanDataTitle" :key="title">
          {{ title }}
        </span>
        <span class="u_spanData" style="margin-left: 200px;">
          标题 :
        </span>
        <a-input style="width:120px;margin-left: 15px;margin-right: 15px;" v-model="key" placeholder="请输入标题" />
        <a-button icon="search" @click="ButtonClick">
          搜索
        </a-button>
      </div>
      <a-table
        v-if="infoType != null"
        :columns="columns"
        :rowKey="record => record.id"
        :data-source="listData"
        :pagination="Infopagination"
      >
        <a @click="TextcontentClick(record.id)" style="color:#000" slot="title2" slot-scope="text, record">
          <img :src="dot" style="margin-right:5px;">{{ text | titleFilter(title) }}</a>
        <a @click="TextcontentClick(record.id)" style="color:#000" slot="publishTime" slot-scope="text, record">{{
          text | moment('YYYY-MM-DD')
        }}</a>
      </a-table>
      <a-table
        v-if="SdType != null"
        :columns="SupplyAndDemandcolumns"
        :rowKey="record => record.id"
        :data-source="SupplyAndDemandData"
        :pagination="supplypagination"
      >
        <a @click="SupplyandDemandClick(record.id)" style="color:#000" slot="sdTitle2" slot-scope="text, record">{{
          text | titleFilter(title)
        }}</a>
        <a @click="SupplyandDemandClick(record.id)" style="color:#000" slot="publishTime" slot-scope="text, record">{{
          text | moment('YYYY-MM-DD')
        }}</a>
      </a-table>
    </div>
    <div style="clear:both"></div>
  </div>
</template>
<script>
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { SupplyAndDemandInfoWebPage } from '@/api/main/SupplyAndDemandManager'
import parmSetting from '@/config/parmSetting'
import dot from '@/assets/icon/dot.png'

export default {
  data() {
    return {
      id: '',
      title: '',
      dot: dot,
      orgId: null,
      SdType: '',
      key: '',
      CType: '',
      infoType: null,
      listData: [],
      SupplyAndDemandData: [],
      /** 分页栏显示 */
      Infopagination: {
        pageSize: 10,
        current: 1,
        total: 20,
        onChange: (current, pageSize) => {
          this.Infopagination.current = current
          this.Infopagination.pageSize = pageSize
          this.loadData()
        }
      },
      supplypagination: {
        pageSize: 10,
        current: 1,
        total: 20,
        onChange: (current, pageSize) => {
          this.supplypagination.current = current
          this.supplypagination.pageSize = pageSize
          this.SupplyAndDemandInfoWebPage()
        }
      },
      columns: [
        {
          title: '标题',
          dataIndex: 'title',
          align: 'left',
          scopedSlots: { customRender: 'title2' }
        },
        {
          title: '发布时间',
          dataIndex: 'publishTime',
          width: 140,
          scopedSlots: { customRender: 'publishTime' }
        }
      ],
      SupplyAndDemandcolumns: [
        {
          title: '标题',
          dataIndex: 'sdTitle',
          align: 'left',
          weight: '800',
          scopedSlots: { customRender: 'sdTitle2' }
        },
        {
          title: '发布时间',
          dataIndex: 'publishDate',
          width: 140,
          scopedSlots: { customRender: 'publishTime' }
        }
      ]
    }
  },
  methods: {
    loadData() {
      InfoMainWebPage({
        orgId: this.orgId,
        infoType: this.infoType,
        title: this.key,
        pageNo: this.Infopagination.current,
        pageSize: this.Infopagination.pageSize
      }).then(res => {
        this.listData = []
        this.Infopagination.total = res.data.totalRows
        this.Infopagination.current = res.data.pageNo
        this.listData = res.data.rows
      })
    },
    SupplyAndDemandInfoWebPage() {
      SupplyAndDemandInfoWebPage({
        orgId: this.orgId,
        SdType: this.SdType,
        CType: this.CType,
        sdTitle: this.key,
        pageNo: this.supplypagination.current,
        pageSize: this.supplypagination.pageSize
      }).then(res => {
        this.SupplyAndDemandData = []
        this.supplypagination.total = res.data.totalRows
        this.supplypagination.current = res.data.pageNo
        this.SupplyAndDemandData = res.data.rows
      })
    },
    TextcontentClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id, orgId: this.orgId } })
      window.open(go.href, '_blank')
    },
    SupplyandDemandClick(id) {
      const go = this.$router.resolve({ path: 'SupplyandDemandPage', query: { id, orgId: this.orgId } })
      window.open(go.href, '_blank')
    },
    ButtonClick() {
      if (this.infoType) {
        this.Infopagination.current = 1
        this.loadData()
      } else {
        this.supplypagination.current = 1
        this.SupplyAndDemandInfoWebPage()
      }
    }
  },
  mounted() {
    this.key = this.$route.query.key
    this.orgId = this.$route.query.orgId
    const parm = parmSetting.filter(item => item.nc === this.$route.query.nc)
    this.title = parm[0].title
    document.title = this.title
    this.infoType = parm[0].infoType
    this.SdType = parm[0].SdType
    this.CType = parm[0].CType
    // eslint-disable-next-line eqeqeq
    if (this.infoType == null) {
      this.SupplyAndDemandInfoWebPage()
    } else {
      this.loadData()
    }
  },
  filters: {
    titleFilter: val => {
      if (val.length > 35) {
        return val.slice(0, 35) + '...'
      } else {
        return val
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(val, from) {
        const parm = parmSetting.filter(item => item.nc === val.query.nc)
        if (parm && parm.length > 0) {
          this.title = parm[0].title
          this.infoType = parm[0].infoType
          this.SdType = parm[0].SdType
          this.CType = parm[0].CType
        } else {
          alert('失败！,系统出错')
        }
      }
    }
  }
}
</script>
